import { Component, inject, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { BreakpointService } from '@core/services/breakpoint.service';
import { WINDOW } from '@core/configs/token.config';

@Component({
  selector: 'app-back-to-overview',
  templateUrl: './back-to-overview.component.html',
  styleUrls: ['./back-to-overview.component.scss'],
  standalone: false,
})
export class BackToOverviewComponent {
  @Input() public text: string;
  @Input() public url: string | string[];

  readonly #location = inject(Location);
  readonly #router = inject(Router);
  readonly #window = inject(WINDOW);

  constructor(public readonly breakpointService: BreakpointService) {}

  public goBack(): void {
    // Prefer real back-navigation so the router restores the previous scroll position;
    // fall back to the overview URL when the detail was opened directly (no in-app history).
    if (this.#hasInAppHistory()) {
      this.#location.back();

      return;
    }

    if (!this.url) {
      return;
    }

    if (Array.isArray(this.url)) {
      this.#router.navigate(this.url);
    } else {
      this.#router.navigateByUrl(this.url);
    }
  }

  #hasInAppHistory(): boolean {
    return (this.#window.history.state?.navigationId ?? 0) > 1;
  }
}
